import { visitPreInfos } from '../preInfo'
import { describeTable } from './describeTable'

describeTable(visitPreInfos, {
  description: `The pre-visit questionnaire (ennakkotiedot) for one visit, used for ventilation jobs: we ask the customer about access and the ventilation plans before the technician arrives. One row per visit; requested_at → submitted_at → internal_reviewed_at is the lifecycle. Answers that describe the house itself (unit model, plans on file, access notes) are written to properties.ventilation, so this row only holds the per-visit answers and the review state.
A visit with no row was never asked; requested_at set and submitted_at NULL = customer has not answered (reminder nudges are tasks/notifications, not rows here).`,
  columns: {
    requestedAt: 'When the questionnaire link was sent to the customer.',
    submittedAt: 'When the customer answered; NULL = pending.',
    submittedVia:
      'form = customer filled the web form; phone / email = staff recorded the answers on their behalf.',
    accessConfirmed:
      'Customer confirmed the technician can access the machine and ducts.',
    plansDelivery:
      'uploaded = ventilation drawings attached in advance; onsite = they will be shown at the visit.',
    notes: 'Free text from the customer.',
    internalReviewedAt: 'When staff reviewed the answers; NULL = unreviewed.',
    internalReviewedBy: 'Staff reviewer.',
    internalReviewComment: 'Staff comment from the review.',
  },
})
